/**
 * Kiosk constants
 *
 * Simple explanation: Shared numbers, colors, and sizes used by kiosk screens
 * and map icons so everything stays consistent.
 *
 * Technical summary:
 * - Default map center/zoom and bounds limits
 * - UI timings (snackbar), table scrollbar styles
 * - Icon sizes and status color palette for map markers
 */

// Default timer value for station display rotation
export const DEFAULT_TIMER = "8";

// Default map configuration
export const DEFAULT_MAP_CENTER = [72.49408333333334, -81.69515];
export const DEFAULT_MAP_ZOOM = 5.2;

// Map configuration limits
export const MAP_MIN_ZOOM = 3;
export const MAP_MAX_ZOOM = 10;

/**
 * pigeon-maps `limitBounds`: the default `'center'` only clamps the map center to Web Mercator
 * limits, so viewport edges can still show empty grey near the poles. Any value other than
 * `'center'` tells pigeon-maps to clamp the center so the full viewport stays within tile
 * coverage (see library `getBoundsMinMax` / `limitCenterAtZoom`).
 * @see https://pigeon-maps.js.org/docs/
 */
export const PIGEON_MAP_LIMIT_BOUNDS_FULL_VIEWPORT = "viewport";

// Snackbar configuration
export const SNACKBAR_AUTO_HIDE_DURATION = 2500;

// Table styling constants
export const TABLE_SCROLLBAR_WIDTH = 18;
export const TABLE_SCROLLBAR_COLORS = {
  background: "#e0e0e0",
  thumb: "#bdbdbd",
};

// Icon configuration
export const ICON_SIZES = {
  weatherStation: { width: 30, height: 30 },
  customPin: { width: 40, height: 60 },
  customIcon: { width: 45, height: 60 },
};

// Status colors for station icons
export const STATUS_COLORS = {
  operational: "#78a62b",
  warning: "#f2d666",
  nonOperational: "#ad4242",
  unknown: "#E0E0E0",
  error: "#ad4242",
};

// Text colors for status indicators
export const STATUS_TEXT_COLORS = {
  operational: "blue",
  warning: "#d4a012",
  nonOperational: "#ad4242",
  unknown: "#666666",
  error: "#ad4242",
};
